import {Button} from '~/components';
import {Text} from '../elements/Text';
import {SpreadMedia} from '../media/SpreadMedia';
import {CardWithBottomSectionEntity} from '~/types/TwoCardsWithBottomSectionEntity';
import {DATA_TEST_IDS} from '~/lib/const';

export function TwoCardsWithBottomSectionItem({
  card,
}: {
  card: CardWithBottomSectionEntity;
}) {
  return (
    <div
      data-testid={DATA_TEST_IDS.TWO_CARDS_WITH_BOTTOM_SECTION_ITEM}
      className="w-full lg:w-1/2"
    >
      <div className="w-full aspect-square">
        <SpreadMedia
          media={card}
          breakpoints={[
            [360, 360],
            [670, 670],
          ]}
        />
      </div>

      <div className="flex flex-col items-start">
        {(card.title || card.description) && (
          <div className="mt-[23px] max-w-[748px] text-black">
            {card.title && (
              <Text
                testid={DATA_TEST_IDS.TWO_CARDS_WITH_BOTTOM_SECTION_TITLE}
                as="h2"
                className="line-clamp-2"
              >
                {card.title.toUpperCase()}
              </Text>
            )}

            {card.description && (
              <div className="mt-[7px] md:mt-[18px] line-clamp-2 md:w-3/4 md:h-12 leading-5">
                <Text
                  testid={
                    DATA_TEST_IDS.TWO_CARDS_WITH_BOTTOM_SECTION_DESCRIPTION
                  }
                  className="text-16/19 md:text-18/26"
                >
                  {card.description}
                </Text>
              </div>
            )}
          </div>
        )}
        <div className="space-x-[30px]">
          {card.buttons?.map((button) => (
            <Button
              data-testid={DATA_TEST_IDS.BUTTON('two-cards-with-bootm')}
              maxWidth={250}
              to={button.buttonHref}
              key={button.buttonText}
              variant={button.buttonType}
              width={button.buttonWidth}
              className="mt-[18px] lg:mt-6 md:mt-9 truncate"
            >
              {button.buttonText?.toUpperCase()}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
